import React from 'react'
import { FaSearch } from 'react-icons/fa'
import "./Merchant.css";

function MerchantHeader() {
  return (
    <div className='data-head'>
        
        <h2 className="area-top-management">Merchant Management</h2>
     
      <div className="search-divs-manage">
        <div className="search">
          <input
            type="text"
            className="search-input-user-management"
            placeholder="Search"
            // onChange={handleChange}
          />
          <FaSearch className="search-icon-user-management" />
        </div>
       
      </div>
    </div>
  )
}

export default MerchantHeader
